<app-topheader></app-topheader>
<div class="scrollingcontainer container">
    <app-fancy-page-title topTitle="AMERICAN EXPLORER"></app-fancy-page-title>
    <div class="blueletters">Welcome Aboard {{shipname}}</div>
    <app-goldbar></app-goldbar>
    <!-- <app-current-date></app-current-date> -->
    <div class="tenpxtop"></div>
    <div class="">

        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/myday']">
                    <div class="col-12 leftwidget ">

                        <div class="widgetborder">

                            <div *ngIf="pagemask == false" class="widgetsublabel">My Day</div>
                            <div *ngIf="pagemask == true" class="widgetsublabel">First Day</div>

                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="tenpxtop"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/pci']">
                    <div class="col-12 rightwidget ">

                        <div class="widgetborder">

                            <div *ngIf="pagemask == false" class="widgetsublabel">Planned Cruise Itinerary</div>
                            <div *ngIf="pagemask == true" class="widgetsublabel">Planned Itinerary</div>

                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- <div class="tenpxtop"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/mealdescription']">
                    <div class="col-12 leftwidget ">

                        <div class="widgetborder">

                            <div class="widgetsublabel">Dining Times & Menu Selections</div>
                        </div>
                    </div>
                </a>
            </div>
        </div> -->
        <div class="tenpxtop"></div>
        <!--Show if guest-->
        <div class="row" *ngIf="employeeData?.EmployeeNo == undefined">
            <div class="col-12 widgetlinkarea">


                <div class="">
                    <app-shore-excursion-signup></app-shore-excursion-signup>
                </div>


            </div>
        </div>
        <!--Show if crew-->
        <div class="row" *ngIf="employeeData?.EmployeeNo != undefined">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/excursions']">
                    <div class="col-12 rightwidget ">

                        <div class="widgetborder">
                            <div class="widgetsublabel">Shore Excursions & Transfers</div>
                        </div>

                    </div>
                </a>


            </div>
        </div>

        <div class="tenpxtop"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/entertain']">
                    <div class="col-12 leftwidget ">
                        <div class="widgetborder">

                            <div class="widgetsublabel">Onboard Entertainment & Enrichment</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- Points of Interest: hidden unless config `showPointsOfInterest` is true.
             To unhide: set `"showPointsOfInterest": true` in deployed assets/config.json;
             see AppConfigService.showPointsOfInterest. -->
        <div class="tenpxtop" *ngIf="showPointsOfInterest"></div>
        <div class="row" *ngIf="showPointsOfInterest">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/enrichmentguide']">
                    <div class="col-12 rightwidget ">
                        <div class="widgetborder">

                            <div class="widgetsublabel">Points of Interest</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div *ngIf="pagemask == false">
        <div class="tenpxtop widgetlinkarea"></div>
        <div class="row">
            <!-- always show the survey icon -->
            <div class="col-12 widgetlinkarea">
                <a href="https://questionpro.com/t/ATOnPZ4Wrm?BookingCode={{rebcode}}&CruiseCode={{evtcode}}">
                    <div class="col-12 midwidget ">

                        <div class="widgetborder">
                            <div class="widgetsublabel">Guest Feedback</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        </div>

        <div class="tenpxtop widgetlinkarea"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/crew']">
                    <div class="col-12 midwidget ">

                        <div class="widgetborder">
                            <div class="widgetsublabel">Meet Your Officers</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- <div class="tenpxtop widgetlinkarea"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a [routerLink]="['/rebook']">
                    <div class="col-12 leftwidget ">

                        <div class="widgetborder">
                            <div class="widgetsublabel">Your Next Adventure</div>
                        </div>
                    </div>
                </a>
            </div>
        </div> -->

        <!-- <div class="tenpxtop widgetlinkarea"></div>
        <div class="row">
            <div class="col-12 widgetlinkarea">
                <a href="https://store.americancruiselines.com" target=”_blank”>
                    <div class="col-12 rightwidget ">

                        <div class="widgetborder">
                            <div class="widgetsublabel">Gift Shop</div>
                        </div>
                    </div>
                </a>
            </div>
        </div> -->




        <div class="tenpxtop"></div>

    </div>


</div>
<app-bottommenu></app-bottommenu>